export default __webpack_public_path__ + "static/media/Frame.cd965fdc.png";